import { AuthContextProps } from "../components/auth-context";
import { putData } from "./core";

export default class FileOpApi {
  static uri = "file";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  terminateCurrentService(id: number) {
    return putData({
      uri: `${FileOpApi.uri}/TerminateCurrentService`,
      id,
      context: this.context,
    });
  }

  ChangeComment(id: number, comment: string) {
    return putData({
      uri: `${FileOpApi.uri}/ChangeFileComment`,
      id,
      params: `?comment=${comment}`,
      context: this.context,
    });
  }
}
